import React from 'react';
import { useSelector } from 'react-redux';

import { AppState } from 'services/types';
import { numberOfDays } from 'utils/formatter/number-of-days';
import ListItem from 'components/ListItem';
import { FertilizerProductId } from 'services/fertilizerProducts/types';
import { makeSelectReEntryPeriodDays } from './selectors';

export interface Props {
    productId: FertilizerProductId;
}

export default function FertilizerEventReEntryPeriodListItem(
    props: Props
): React.ReactElement {
    const reEntryPeriod = useSelector((state: AppState) =>
        makeSelectReEntryPeriodDays()(state, props)
    );

    return (
        <ListItem
            value={
                typeof reEntryPeriod === 'number'
                    ? numberOfDays(reEntryPeriod)
                    : ''
            }
            description="Re-entry period"
        />
    );
}
